<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="货币单位">
      <a-input v-model="form.data.paramKey"/>
    </a-form-model-item>
    <a-form-model-item label="价格">
      <a-input v-model="form.data.paramValue"/>
    </a-form-model-item>
    <a-form-model-item label="国家">
      <a-input v-model="form.data.country"/>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
        <a-button type="primary" v-if="!goodsPriceId" @click="onAdd">创建</a-button>
        <a-button type="primary" v-if="goodsPriceId" @click="onUpdate">更新</a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _queryPrices,
  _updatePrice,
  _addPrice,
} from '@/api/websiteGoodsPriceApi'

async function getPrices() {
  const result = await _queryPrices(this.goodsPriceId);
  if (result) {
    this.form.data.paramKey = result.paramKey;
    this.form.data.paramValue = result.paramValue;
    this.form.data.country = result.country;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addPrice({
        country: this.form.data.country,
        paramKey: this.form.data.paramKey,
        paramValue: this.form.data.paramValue,
        goodsId: this.goodsId,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updatePrice(this.goodsPriceId, {
        country: this.form.data.country,
        paramKey: this.form.data.paramKey,
        paramValue: this.form.data.paramValue,
        goodsId: this.goodsId,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler()
  }
}

export default {
  name: 'GoodsPriceEdit',
  props: {
    goodsPriceId: String,
    goodsId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    goodsPriceId() {
      if (this.goodsPriceId) {
        this.getGoodsTag()
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getPrices,
  },
  data() {
    return {
      form: {
        data: {
          paramValue: '',
          paramKey: '',
          country: '',
        },
        rules: {
          paramKey: [{ required: true, trigger: 'blur' }],
          paramValue: [{ required: true, trigger: 'blur' }],
        },
        title: '',
      },
    }
  },
  created() {
    if (this.goodsPriceId) {
      this.getPrices()
    }
  },
}
</script>
